// 传入当前语言 (locale)，返回计算好的星期
export const getWeekday = (dateString: string, currentLocale: string) => {
  if (!dateString || dateString === '等待开奖' || dateString.includes('-') === false) return '';
  const d = new Date(dateString);
  if (isNaN(d.getTime())) return '';
  return d.toLocaleDateString(currentLocale === 'zh' ? 'zh-CN' : 'en-US', { weekday: 'long' });
}
